import type { Form } from '../../../common/types/form';
import type { Client } from '../../../common/types/client';

const contactForm: Form<Client> = {
  key: 'contactForm',
  title: 'Kontaktaufnahme',
  fields: [
    {
      key: 'awareOfInstitution',
      label: 'Wie wurde die Patientin auf Ihre Institution aufmerksam?',
      fieldTypes: 'select',
      options: [
        {
          value: 'selfInitiative',
          label: 'Patientin in Eigeninitiative',
        },
        {
          value: 'mother',
          label: 'Mutter der Patientin',
        },
        {
          value: 'familyMember',
          label: 'Ein anderes Familienmitglied',
        },
        {
          value: 'partner',
          label: 'Partner*in der Patientin',
        },
        {
          value: 'friend',
          label: 'Eine befreundete Person',
        },
        {
          value: 'otherPerson',
          label: 'Sonstige Person',
        },
        {
          value: 'media',
          label: 'Medien / Verzeichnisse',
        },
        {
          value: 'internet',
          label: 'Internet',
        },
        {
          value: 'consultingCenter',
          label: 'Beratungsstelle',
        },
        {
          value: 'psychotherapist',
          label: 'Niedergelassene*r Psychotherapeut*in',
        },
        {
          value: 'clinic',
          label: 'Klinik',
        },
        {
          value: 'doctor',
          label: 'Ärztin / Arzt',
        },
        {
          value: 'school',
          label: 'Schule / Ausbildungs- / Arbeitsstätte',
        },
        {
          value: 'office',
          label: 'Ämter',
        },
        {
          value: 'other',
          label: 'Sonstiges',
        },
      ],
    },
    {
      key: 'awareOfInstitutionFamilyMember',
      label: 'Familienmitglied, und zwar',
      fieldTypes: 'text',
      isVisible: (client) => client.awareOfInstitution != null && client.awareOfInstitution === 'familyMember',
    },
    {
      key: 'awareOfInstitutionOtherPerson',
      label: 'Familienmitglied, und zwar',
      fieldTypes: 'text',
      isVisible: (client) => client.awareOfInstitution != null && client.awareOfInstitution === 'otherPerson',
    },
    {
      key: 'awareOfInstitutionDoctor',
      label: 'Fachrichtung',
      fieldTypes: 'text',
      isVisible: (client) => client.awareOfInstitution != null && client.awareOfInstitution === 'doctor',
    },
    {
      key: 'awareOfInstitutionOther',
      label: 'Sonstiges, und zwar',
      fieldTypes: 'text',
      isVisible: (client) => client.awareOfInstitution != null && client.awareOfInstitution === 'other',
    },
    {
      key: 'contact',
      label: 'Die Kontaktaufnahme erfolgte',
      fieldTypes: 'select',
      options: [
        {
          value: 'duringPhoneConsultationHour',
          label: 'telefonisch während der Telefonsprechstunde',
        },
        {
          value: 'duringGeneralSpeakingTime',
          label: 'telefonisch während der allgemeinen Sprechzeiten',
        },
        {
          value: 'voiceMailAndCallback',
          label: 'durch Nachricht auf AB und Rückruf',
        },
        {
          value: 'byWriting',
          label: 'schriftlich / E-Mail',
        },
        {
          value: 'personally',
          label: 'persönlich',
        },
      ],
    },
  ],
};

export default contactForm;
